import { AxiosProgressEvent } from "axios";
import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import commonUtils, { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";
export const contractDelete = async (
  type: string,
  uuid: string,
  id: string
) => {
  const path = commonUtils.getUrlReplace(
    type === CONSTANTS.DOCUMENT.OFFICE
      ? API_URL.PROFILE.CONTRACT_DELETE_OFFICE
      : API_URL.PROFILE.CONTRACT_DELETE_PROFESSIONAL,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  const url = commonUtils.getUrlReplace(path, COMMON_CONSTANTS.UUID, id);
  return await apiCall.remove(url);
};
export const contractUpload = async (
  data: FormData,
  pay_scale_assignment_uuid?: string | null
) => {
  if (pay_scale_assignment_uuid) {
    data.append("pay_scale_assignment_uuid", pay_scale_assignment_uuid);
  }
  const res = await apiCall.fileUploadApi(
    API_URL.PROFILE.CONTRACT_UPLOAD,
    data
  );
  return res;
};

export const getAdminCommonInfoData = async (type: string = "") => {
  const res = await apiCall.get(API_URL.COMMON.COMMON_INFO + type);
  return res;
};

export const getCityList = async (searchTerm: string = "") => {
  const res = await apiCall.get(API_URL.COMMON.CITY + searchTerm);
  return res;
};
export const getCityDetails = async (id: string) => {
  const res = await apiCall.get(API_URL.COMMON.GET_CITY_DETAILS + id);
  return res;
};
export const getCommonInfoData = async (type: string = "") => {
  const res = await apiCall.get(API_URL.COMMON.COMMON_INFO + type);
  return res;
};

export const fileUpload = async (
  data: FormData,
  options?: {
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
  }
) => {
  const res = await apiCall.fileUploadApi(
    API_URL.PROFILE.FILE_UPLOAD,
    data,
    options?.onUploadProgress
  );
  return res;
};

export async function getLogNotes(uuid: string) {
  const url = urlReplace(
    API_URL.COMMON.LOG_NOTE,
    COMMON_CONSTANTS.NOTE_UUID,
    uuid
  );
  const res = await apiCall.get(url);
  return res;
}
export const validateEmail = async (email: string) => {
  const res = await apiCall.post(API_URL.COMMON.EMAIL_VALIDATE, { email });
  return res;
};
